// メッセージ設計書のメッセージ一覧（フロント・バック共用のメッセージコードとメッセージ文）
const ErrorTodoMessages = Object.freeze({
  // ERAE
  ERAE40001: "リクエストが不正です",
  ERAE40002: "データが最新の状態ではなかったため、処理に失敗しました",
  ERAE40003: "権限がありません ",
  ERAE40005: tableName => `${tableName}に値が存在しません。`,
  ERAE40007: counts => `検索結果が${counts}件を超えました`,
  ERAE50001: "SQLエラーが発生しました",
  ERAE50002: "想定外のエラーが発生しました",
  // ERWE
  ERWE40001: "IDとパスワードを入力してください。",
  ERWE40002: "ID、パスワードの入力に誤りがあります。",
  ERWE40004: "必須項目です。",
  ERWE40007:
    "ファイルの読み込みに失敗しました。\nシステム管理者に問い合わせて下さい。",
  ERWE40008: "数値を入力してください。",
  ERWE40010:
    "ファイル形式が正しくありません。\nCSVファイルを選択してください。",
  ERWE40011: (...args) =>
    `ファイルの発行単位が異なります。\n発行単位が同じファイルを選択してください。\n画面選択発行単位：${args[0]}\nファイル発行単位：${args[1]}`,
  ERWE40013: (...args) =>
    `ファイルの施設名が異なります。\n施設名が同じファイルを選択してください。\n画面選択施設名：${args[0]}\nファイル施設名：${args[1]}`,
  ERWE40014: (...args) =>
    `ファイルの年度が異なります。\n年度が同じファイルを選択してください。\n画面選択年度：${args[0]}\nファイル年度：${args[1]}`,
  ERWE40012: "カナ文字を入力してください。",
  ERWE40015: num => `${num}桁の数値を入力してください。`,
  ERWE40016: "yyyymmddの表記で入力してください。",
  ERWE40017: "半角数字7桁で入力してください。",
  ERWE40018:
    "発行単位の名称はすでに登録されています。\n日付を入力するなどして、一意な名称にして再度登録してください。",
  ERWE40019:
    "発行単位の名称はすでに登録されています。\n学校名と年度と学年を入力するなどして、一意な名称にして再度登録してください。",
  ERWE40020:
    "発行単位の名称はすでに登録されています。\n施設名を入力するなどして、一意な名称にして再度登録してください。",
  ERWE40021: "申し訳ございません。システムエラーが発生しました。",
  ERWE40022:
    "お手数ですが、もう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40023:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40024:
    "お手数ですが、トップ画面から操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40025:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40026:
    "お手数ですが、上記検索結果件数を下回るように検索条件を見直してください。",
  ERWE40027:
    "お手数ですが、もう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40028:
    "お手数ですが、もう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40029:
    "パスワードとパスワード（確認用）には同一のものを入力してください。",
  ERWE40033: "生徒情報が未登録です。生徒情報を登録してから、実行してください。",
  ERWE40036: "パスワードポリシーを満たしておりません。",
  ERWE40037: "全角文字を入力してください。",
  ERWE40038:
    "お手数ですが、時間をおいてもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40039: "英数字を入力してください。",
  ERWE40040: "既に発令済みの避難情報に対して続報を送信してください。",
  ERWE40041:
    "システムエラーの発生、または予期せぬ操作が行われました。\nお手数ですが、トップページからシステムをお使いください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE40044: "yyyy/mm/ddの表記で入力してください。",
  // 地図システム
  ERWE40047: "システム管理者へお問い合わせください。",
  // ERAE47
  ERAE47001: "%1が存在する%2は削除できません",
  ERAE47002: "%1情報が存在しません",
  ERAE47003: "%1情報は削除されています",
  ERAE47004: "この%s情報は既に登録されています",
  ERAE47005: "同じ車番の管理車両が既に登録済みです",
  ERAE47011: "入力ファイルの内容が不正です（以下に先頭30件までエラー詳細表示）",
  ERAE47018: "入力ファイルの内容が不正です",
  ERAE47021: "避難車両配車システムの権限情報の取得に失敗しました",
  ERAE47022:
    "要配慮者施設または原子力災害関係施設が登録されていません\nまたは、ユーザと施設の紐付けが正しくありません",
  ERAE47023:
    "車両事業者が登録されていません\nまたは、ユーザ名と車両事業者名が一致しません",
  ERAE47025: "避難車両配車システムの表示に失敗しました",
  ERAE47026: "同じ車両事業者区分、車両事業者名の車両事業者が既に登録済みです",
  // ERWE47
  ERWE47003:
    "CSVファイルのヘッダ部の内容が正しくありません。\n正しい手順でCSVファイルが保存されていることを確認してください。",
  ERWE47004:
    "未登録の場合は要配慮者施設または原子力災害関係施設を登録し、施設とユーザを同じ組織に紐付けてください。",
  ERWE47005:
    "未登録の場合は車両事業者を登録し、下記の例を参考に車両事業者名とユーザ名を一致させてください。\n　営業所ありの場合）　ユーザ名を「車両事業者名：営業所名」とする\n　営業所なしの場合）　ユーザ名を「車両事業者名」とする",
  ERWE47008:
    "該当データに紐づくデータを削除した上で、再度操作を行ってください。",
  ERWE47009:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE47010:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE47011:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE47012:
    "同じ車番の管理車両を検索して確認してください。\n必要に応じて、別の車番で登録してください。",
  ERWE47013:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE47014:
    "お手数ですが、画面を再読み込み後にもう一度操作をやり直してください。\n再度発生した場合、システム管理者へお問い合わせください。",
  ERWE47015:
    "同じ車両事業者区分、車両事業者名の車両事業者を検索して確認してください。\n必要に応じて、別の車両事業者区分、車両事業者名で登録してください。",
  // 調整システム
  ERWE48001: "対象データが存在しません。\n一覧を表示してから実行してください。",
  ERWE48002: "代替避難先の候補を選択してください。",
  ERWE48003: "代替避難先の候補を選択解除してください。",
  ERWE48004: "対象データが存在しません。",
  ERWE48005: txt =>
    `対象データが存在しません。\n${txt}を変更してから実行してください。`,
  ERWE48007: "ログイン情報を確認できませんでした。画面を閉じてください。",
  ERWE48008: num =>
    `マッチング対象件数（受入困難な避難元件数 × 代替の避難先件数）が上限（${num}件）を超えました。\n代替の避難先の検索条件を変更して、再検索を行ってください。`
});

// バッグ側から取得したエラーメッセージコードごとに画面表示メッセージを出しわける（※フロント専用変数）
const ErrorTodoMessagesForFront = Object.freeze({
  ERAE40001: ErrorTodoMessages.ERWE40022,
  ERAE40002: ErrorTodoMessages.ERWE40023,
  ERAE40003: ErrorTodoMessages.ERWE40024,
  ERAE40004: screenId => {
    switch (screenId) {
      // 仮QRコード発行単位登録画面の場合
      case "SF0607":
        return ErrorTodoMessages.ERWE40018;
      // 学校ＱＲコード発行単位登録画面の場合
      case "SF0604":
        return ErrorTodoMessages.ERWE40019;
      // 要配慮者施設QRコード発行単位登録画面の場合
      case "SF0601":
        return ErrorTodoMessages.ERWE40020;
      default:
        return "";
    }
  },
  ERAE40005: ErrorTodoMessages.ERWE40025,
  ERAE40007: ErrorTodoMessages.ERWE40026,
  ERAE50001: ErrorTodoMessages.ERWE40027,
  ERAE50002: ErrorTodoMessages.ERWE40028,
  ERGE50001: ErrorTodoMessages.ERWE40047,
  ERAE40010: ErrorTodoMessages.ERWE40040,
  ERAE47001: ErrorTodoMessages.ERWE47008,
  ERAE47002: ErrorTodoMessages.ERWE47009,
  ERAE47003: ErrorTodoMessages.ERWE47010,
  ERAE47004: ErrorTodoMessages.ERWE47011,
  ERAE47005: ErrorTodoMessages.ERWE47012,
  ERAE47018: ErrorTodoMessages.ERWE47003,
  ERAE47021: ErrorTodoMessages.ERWE47013,
  ERAE47022: ErrorTodoMessages.ERWE47004,
  ERAE47023: ErrorTodoMessages.ERWE47005,
  ERAE47025: ErrorTodoMessages.ERWE47014,
  ERAE47026: ErrorTodoMessages.ERWE47015
});

export { ErrorTodoMessages, ErrorTodoMessagesForFront };
